import { render, staticRenderFns } from "./TheSatellite.vue?vue&type=template&id=1a405715&scoped=true&"
import script from "./TheSatellite.vue?vue&type=script&lang=js&"
export * from "./TheSatellite.vue?vue&type=script&lang=js&"
import style0 from "./TheSatellite.vue?vue&type=style&index=0&id=1a405715&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a405715",
  null
  
)

export default component.exports